import {appContainer} from "../contexts/app";
import Resource from "./resource";
import {fromImmutable, toImmutable, setInState, setListInState, deleteInState, validate} from "./hooks";

export default app => {
  const service = app.service("api/groups");

  const GroupRecord = Resource(service, {
    account_id: "",
    name: ""
  });

  const validateCategory = validate({
    name: "Group name is required."
  });

  appContainer.GroupRecord = GroupRecord;
  app.set("GroupRecord", GroupRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable, validateCategory],
      update: [fromImmutable, validateCategory],
      patch: [fromImmutable, validateCategory],
      remove: []
    },

    after: {
      all: [toImmutable(GroupRecord)],
      find: [setListInState("groups")],
      get: [setInState("groups")],
      create: [setInState("groups")],
      update: [setInState("groups")],
      patch: [setInState("groups")],
      remove: [deleteInState("groups")]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/groups.js